module.exports = __webpack_public_path__ + "media/images/icons/icn_033-6931e5248383ec244a9bb3bf9b08e45f.svg";